/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Projects_Card_UpdatedInputs */



/**
* | output |
* | --- |
* | "Updated {time}" |
*
* @param {Projects_Card_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_card_updated = /** @type {((inputs: Projects_Card_UpdatedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Card_UpdatedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Aktualisiert ${i?.time}`)
	return /** @type {LocalizedString} */ (`Updated ${i?.time}`)
});